import axios from "axios";
import { useAtomValue } from "jotai";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useAuth } from "../../../context/authContext";
import { documentAPI } from "api";
import { loginRedirectURIState } from "../../../global/state/global";
import { iTeam, iUserSecrets } from "typings";
import Button from "../../1_atom/buttons/button";
import LoginButton from "../../1_atom/loginButton/loginButton";
import { getErrorMessage, getLoginRedirectString, processAxiosResponseCatchMe } from "functions";

const JoinTeamModal = () => {
  const loginRedirectURI = useAtomValue(loginRedirectURIState)
  const auth = useAuth()
  const [teams, setTeams] = useState<iTeam[] | null>(null)
  const userAPI = documentAPI().userAPI
  const teamsAPI = documentAPI().teamsAPI

  useEffect(() => {
    const initServers = async () => {
      const priv = (await userAPI.getPrivate(auth.userData.userID, "secrets")) as iUserSecrets
      if(!priv?.discordUserGuilds) {
        toast("Could not find data on Discord servers, redirecting to login.")
        window.location.replace(getLoginRedirectString({ loginRedirectURI, discordServers: true }));
        return
      }
      const serverIDs = priv.discordUserGuilds?.map((server: any) => server.id)
      const validTeams = await teamsAPI.getAllFromDiscordServerIDs(serverIDs)
      // TODO: filter by ones I'm already in
      setTeams(validTeams)
    }

    initServers()
  }, [])

  if(teams === null) return <p>loading teams..</p>
  if(teams?.length < 1) return <div className="flex-col gap2">
    <p>No eligible teams found. If you think this is a mistake, click the button below to refresh Discord data.</p>
    <LoginButton loginBtnText="Refresh Discord data" />
  </div>
  return (
    <div className="flex-col gap2">
      {teams.map(team => {
        return (
          <div key={team.id} className="left-right-container gap1 bg2 p3 rounded">
            <div className="flex-col">
              <h4>{team.teamName}</h4>
            </div>
            <Button
              text="Join Team"
              click={async () => {
                const joinTeam = async () => {
                  const response = await axios.post(
                    `/api/joinTeam`,
                    {
                      teamID: team.id,
                      userID: auth.userData.userID,
                      discordServerID: team.discordServerID,
                    },
                    { validateStatus: () => true }
                  )
                  await processAxiosResponseCatchMe(
                    response,
                    loginRedirectURI,
                    "Failed to join team.",
                    auth.signout
                  ).catch()
                }

                toast.promise(joinTeam(), {
                  loading: "Joining team",
                  success: "Team joined!",
                  error: (err) => `${getErrorMessage(err)}`,
                });
              }}
            />
          </div>
        )
      })}
      <p className="weak-text">
        Can't find the team you're looking for? Try{" "}
        <a className="link weak-text" href={getLoginRedirectString({ loginRedirectURI, discordServers: true })}>
          refreshing your Discord data
        </a>
        .
      </p>
    </div>
  );
}

export default JoinTeamModal;